module.exports = {"Company Update successfully":"اطلاعات شرکت با موفقیت تغییر یافت","Company Update failed":"تغییر در اطلاعات شرکت با شکست روبرو شد"}